import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import moment from "moment";
import { useNavigate } from "react-router-dom";
// import "./accessbilitydesign.css";
import { Commonfun } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import Loader from "../CommonLoader";
import { AppContext } from "../../../Context/Context";
import CommonAlert from "../../../Commonalert/commonalert";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import DatagridComp from "../DatagridComp";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { toast } from "react-toastify";



const AccessbilityScorescanDetails = () => {
    let querystring = useParams();
    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const ItemId = querystring.id;
    const JobId = querystring.sid;
    const Saudit = querystring.saudit;
    const realJobId = querystring.jobid;

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const urlData = JSON.parse(decodeURIComponent(params.get("urlData")));

    const esodata = useSelector((state) => state);
    const [jobDate, SetjobDate] = useState("");
    const [queryurl, Setqueryurl] = useState("");
    const [issueName, setissueName] = useState("");
    const [loading, setLoading] = useState(false);
    const [apiopen, setapiOpen] = React.useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
    const [autoheightval, SetAutoheightval] = useState(true)

    const navigate = useNavigate();
    const ApiToken = esodata.apiauthkey.value;


    const columns = [
        // {
        //   field: "nid",
        //   headerName: "#",
        //   minWidth: 80,
        //   flex: 1,
        //   disableClickEventBubbling: true,
        //   headerAlign: "center",
        //   align: "center",

        // }
        ,
        {
            field: "impact",
            headerName: "Impact",
            description: "The severity level of the issue detected.",
            minWidth: 150,
            flex: 1,
            disableClickEventBubbling: true,
            headerAlign: "center",
            align: "center",

        },
        {
            field: "issue_name",
            headerName: "Issue Name",
            description: "The specific accessibility issue found.",
            minWidth: 250,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "message",
            headerName: "Message",
            description: "A detailed error message describing the issue.",
            minWidth: 250,
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "html",
            headerName: "Element",
            description: "The HTML element where the issue occurred.",
            minWidth: 350,
            flex: 1,
            headerAlign: "center",
            align: "center",
        }

    ];



    const [ErrorCarddata, SetErrorCarddata] = useState([]);

    const rows = ErrorCarddata ?? [];

    const applyInstantReport = async () => {
        setLoading(true);
        var datavar = `${process.env.REACT_APP_API_URL}instant_report/instant_report_view/?user_domain_id=${esodata.domaindata.value.header_selected}&report_name=${"Accessibility Score"}&url=${urlData.url}&detail_id=${urlData.detail_id}&audit_type=${urlData.audit_type}`
        try {
            const instantReport = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${ApiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (instantReport?.data) {
                if (instantReport?.data) {
                    const dataval = instantReport?.data?.result;
                    const newData = dataval.map((obj, index) => {
                        return { ...obj, sid: index + 1 };
                    });

                    SetAutoheightval(false)

                    SetErrorCarddata(newData)

                    if (instantReport?.data?.job_date)
                        SetjobDate(moment(instantReport?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
                    else
                        SetjobDate(moment(instantReport?.data?.job_date).format("MMMM DD,YYYY"))
                    Setqueryurl(instantReport?.data?.url)
                    setissueName(instantReport?.data?.issue_name)
                }
            }

        } catch (err) {
            console.log('error in get pagenames' + err);
        }
        setLoading(false);

    };

    useEffect(() => {
        applyInstantReport();
    }, []);

    const apihandleClose = () => {
        setapiOpen(false);
    };

    const handleDownlodingCSV = () => {
        downloadPdfCsv("csv");
    }

    const handleDownlodingPDF = () => {
        downloadPdfCsv("pdf");
    }

    const downloadPdfCsv = async (downloadType) => {
        setLoading(true);
        var datavar = `${process.env.REACT_APP_API_URL}instant_report/instant_report_view/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=${downloadType}&timezone=${timezoneval()}&report_name=${"Accessibility Score"}&url=${urlData.url}&detail_id=${urlData.detail_id}&audit_type=${urlData.audit_type}`;
        try {
            const response = await fetch(datavar, {
                method: 'GET',
                headers: {
                    'Content-Type': `application/${downloadType}`,
                    Authorization: `${ApiToken}`,
                },
            });

            if (response.ok) {

                const blob = await response.blob();


                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun("SiteAudit", downloadType, ApiToken, esodata.domaindata.value.header_selected);

                link.download = filedata;
                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error(`Error during ${downloadType} download:`, error);
        }
        setLoading(false);
    }


    return (
        <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
            {loading === true ? <Loader /> : null}
            <Container maxWidth={false} className="dashboard-container">
                <Box className="dashboard-box-time">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={6}>
                            <div className="time_zone">
                                <span><a target="_blank" href={queryurl}>
                                    <span style={{ display: 'inline-block' }} className="spanlink">
                                        {queryurl}
                                    </span>
                                </a>
                                </span><br></br>
                                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                                <span className="timezone-val">{timezoneval()}</span>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={6}>

                        </Grid>
                    </Grid>
                </Box>
            </Container>

            <Container maxWidth={false} className="dashboard-container">
                <Box className="grid_table_shodow">
                    <Grid container className="dashboard-grid">
                        <Grid item xs={12} md={12}>
                            <div className="cnt_audit_outer_wrap">
                                <DatagridComp
                                    columns={columns}
                                    rows={rows}
                                    autoheightval={autoheightval}
                                    datagridval={2}
                                    columnFreezeWidth={[0, 150]}
                                    handleDownlodingCSV={handleDownlodingCSV}
                                    handleDownlodingPDF={handleDownlodingPDF}
                                    customFilter={false}
                                    DownloadShowFile={true}
                                    DownloadShowPDF={1}
                                    DownloadShowCSV={urlData ? 1 : 2}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Container>


            <div className="cnt_audit_outer_wrap">
                <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
                {!openCommonAlerts &&
                    <CommonErrorAlert
                        data={{
                            apiopen: apiopen,
                            apiErrorMsg: apierrorMsg,
                            isIconStyled: false
                        }}
                        closeAlert={apihandleClose} />
                }
            </div>
        </div>
    );
};

export default AccessbilityScorescanDetails;
